import React from 'react';
import { useTranslation } from 'react-i18next';
import { SVG, Icons } from '../SVG';
import { Namespace } from '../../../translation/namespace';

export function LoadingSpinner() {
  const { t } = useTranslation(Namespace.LoadingSpinner);

  return (
    <span className="loading-spinner" aria-hidden="true">
      <span className="loading-spinner__fallback-icon" title={`${t('loading')}\u2026`}>
        <SVG svgSpriteId={Icons.HOUR_GLASS} />
      </span>
    </span>
  );
}
